export default {
  search: "搜索",
  dataMarket: "浏览数据集市",
};
